import { socketService } from '../socket/socket.service';
import { generateRequestId } from '../general-utils';

export default class SofyAbortController extends AbortController {
  constructor() {
    super();
    this.requestId = generateRequestId();
  }

  _abortRequest() {
    try {
      socketService.emit('abortRequest', this.requestId);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Socket emit failed', err);
    }
  }

  abort() {
    this._abortRequest();
    super.abort();
  }
}
